import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm, getFormValues, getFormSyncErrors } from "redux-form";
import userContext from "../../userContext";
import CompanyInfoForm from "./CompanyInfoForm";
import { FORM_NAME } from "../companyInfo.constants";
import controls from "../../controls";
import utilities from "../../utilities";
import { fetchOrders as fetchOrdersCreator } from "../../order/order.actions";
import { getUserHasSubmittedOrder } from "../../order/order.selectors";
import { saveOnBlur } from "../../userContext/userContext.actions";
import { getFieldOnTab } from "../../userContext/userContext.selectors";

const {
  validations: { validateBusinessForm }
} = controls;

const {
  transform: { sanitizeValue }
} = utilities;

const {
  actions: { fetchUser: fetchUserCreator, patchUser: patchUserCreator },
  selectors: {
    getUserContext,
    getRedirect,
    getUserContextExists,
    getUserContextIsBusy
  },
  actions: { logout: logoutCreator }
} = userContext;

class CompanyInfoFormContainer extends Component {
  componentDidMount() {
    this.props.fetchOrders();
  }

  componentDidUpdate(prevProps) {
    const { initialValues, formSyncErrors, touch, untouch } = this.props;
    // We are updating fields on blur. With invalid values.
    /* const {
      initialValues: prevInitialValues,
      formSyncErrors: prevFormSyncErrors
    } = prevProps;

    if (
      initialValues === prevInitialValues ||
      formSyncErrors === prevFormSyncErrors
    )
      return; 
    
    const {
      initialValues: prevInitialValues,
      formSyncErrors: prevFormSyncErrors
    } = prevProps;

    if (
      initialValues === prevInitialValues ||
      formSyncErrors === prevFormSyncErrors
    )
      return; */
    if (this.props.fieldOnTab !== "") {
      // this would be better made into a ref
      const ref = document.getElementsByClassName("CompanyInfoForm")[0];
      if (ref !== undefined) {
        const fieldOnTab = ref.querySelector(
          `[name="${this.props.fieldOnTab}"]`
        );
        fieldOnTab && fieldOnTab.focus();
      }
    }

    if (formSyncErrors) {
      const latestErrors = validateBusinessForm(initialValues);
      touch(
        ...Object.keys(formSyncErrors).filter(k =>
          initialValues.hasOwnProperty(k)
        )
      );
      untouch(
        ...Object.keys(latestErrors).filter(k => latestErrors[k] === undefined)
      );
    }
  }

  handleBlur = e => {
    const { initialValues, patchUser, saveOnBlur } = this.props;
    if (e.nativeEvent && e.nativeEvent.relatedTarget)
      saveOnBlur(e.nativeEvent.relatedTarget.getAttribute("name"));

    if (!e.target.value && !initialValues[e.target.name]) {
      return;
    }

    if (e.target.value === initialValues[e.target.name]) {
      return;
    }
    if (e.target.name === "Country") {
      patchUser({
        [e.target.name]: sanitizeValue(e.target.value),
        State: null,
        Zip: null
      });
    } else {
      patchUser({
        [e.target.name]: sanitizeValue(e.target.value)
      });
    }
  };

  render() {
    const {
      props: { userHasSubmittedOrder, onChange }
    } = this;

    return (
      <CompanyInfoForm
        einIsDisabled={userHasSubmittedOrder}
        formName={FORM_NAME}
        onBlur={this.handleBlur}
        onChange={onChange}
      />
    );
  }
}

CompanyInfoFormContainer.propTypes = {
  patchUser: PropTypes.func.isRequired,
  formSyncErrors: PropTypes.object
};

const mapStateToProps = state => ({
  userHasSubmittedOrder: getUserHasSubmittedOrder(state),
  formValues: getFormValues(FORM_NAME)(state),
  formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
  initialValues: getUserContext(state),
  redirect: getRedirect(state),
  userContextExists: getUserContextExists(state),
  userContextIsBusy: getUserContextIsBusy(state),
  fieldOnTab: getFieldOnTab(state)
});

const mapDispatchToProps = dispatch => ({
  fetchUser: () => dispatch(fetchUserCreator()),
  fetchOrders: () => dispatch(fetchOrdersCreator()),
  patchUser: payload => dispatch(patchUserCreator(payload)),
  logout: () => dispatch(logoutCreator()),
  saveOnBlur: fieldOnTab => dispatch(saveOnBlur(fieldOnTab))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate: validateBusinessForm
  })(CompanyInfoFormContainer)
);
